module.exports = __webpack_public_path__ + "static/media/konsep_2.3941314b.jpg";